export type DiscountPaymentMethod =
  | 'efectivo'
  | 'transferencia'
  | 'mercadopago';

export interface Discount {
  id: string;
  name: string;
  description?: string;
  discountPercentage: number;
  paymentMethods: DiscountPaymentMethod[];
  startDate: string;
  endDate: string;
  isActive: boolean;
}

export interface DiscountPayload {
  name: string;
  description?: string;
  discountPercentage: number;
  paymentMethods: DiscountPaymentMethod[];
  startDate: string;
  endDate: string;
  isActive: boolean;
}

export const PAYMENT_METHOD_LABELS: Record<DiscountPaymentMethod, string> = {
  efectivo: 'Efectivo',
  transferencia: 'Transferencia',
  mercadopago: 'Mercado Pago',
};
